import React from 'react';
import { withStyles, Button } from '@material-ui/core';
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { NavLink } from 'react-router-dom';
import image from "../assets/images/background.jpg";
import AuthenticatedPage from "../ContextAndHOC/AuthenticatedPage";
import {StatusCodes} from 'http-status-codes';

const styles =theme => ({
  main:{
  width: '100%',
  backgroundImage:`url(${image})`,
  backgroundRepeat:"no-repeat",
  backgroundSize:'cover',
  backgroundPosition:'center',
  height:'auto'
  },
  title:{
    color:'white',
    textAlign:'center',
  },
  headingtext:{
    paddingTop:'40px',
    paddingBottom:'40px',
    fontSize:'50px'
  },
  root: {
    width:"100%",
    textAlign:"center",
    backgroundColor:'#ffffff59',
    color:'white',
    height:'100%'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  cardtitle:{
    color:'white',
    fontSize:'2rem',
    textAlign:'center'
  },
  button: {
    height: "40px", width:'200px', margin: "20px 0", marginRight: "20px", backgroundColor: "#2262bf", color: "white",
    fontSize: "13.7px", whiteSpace: "nowrap", cursor: "pointer", borderRadius: "50px", [theme.breakpoints.down("sm")]: { fontSize: '12px', minWidth: "120px" },
  '&:hover': { opacity:'0.8', transition:'0.2s' , backgroundColor:'#2262bf'}
  },
  navlink:{textDecoration:'none'},
  cardaction:{ justifyContent:'center',},
paragraph:{maxWidth:'600px', margin:'auto' ,[theme.breakpoints.down("sm")]: {padding:"10px"},}
});

class ArticleHomePage extends React.Component {
  constructor(props) {
    super(props);
  }

render(){
  const { classes} = this.props;

  return (
    <div className={classes.main}>
      <div className={classes.title}>
        <h1 className={classes.headingtext}>Welcome to MyHope Content Management</h1>
<p className={classes.paragraph}>
This is the place where you can manage all of your content from a single point of connection. Here you can create, edit and remove your content.</p>
      </div>
      <br/><br/><br/>
      <GridContainer>
        <GridItem md={4} lg={4} sm={12} xs={12}style={{paddingTop:"25px"}}>
          <Card className={classes.root}>
            <CardContent>
              <Typography className={classes.cardtitle} color="textSecondary" gutterBottom>
                Articles
              </Typography>
              <Typography component="p" style={{paddingLeft: "9px",paddingRight: "9px"}}>
                Articles is the place where you can enter your article content and view it. Click the button below to go to article dashboard.
              </Typography>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <NavLink to={`${this.props.match.url}/Article`} className={classes.navlink}>
                <Button className={classes.button}>Article Dashboard</Button>
              </NavLink>
            </CardActions>
          </Card>
        </GridItem>
        <GridItem md={4} lg={4} sm={12} xs={12}style={{paddingTop:"25px"}}>
        <Card className={classes.root}>
            <CardContent>
              <Typography className={classes.cardtitle} color="textSecondary" gutterBottom>
                Trivia
              </Typography>
              <Typography component="p"style={{paddingLeft: "11px",paddingRight: "11px"}}>
                Trivia is the place where you can enter your trivia content and view it . Click the button below to go to trivia dashboard .
              </Typography>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <NavLink to={`${this.props.match.url}/Trivia`} className={classes.navlink}>
                <Button className={classes.button}>Trivia Dashboard</Button>
              </NavLink>
            </CardActions>
          </Card>
        </GridItem>
         <GridItem md={4} lg={4} sm={12} xs={12}style={{paddingTop:"25px"}}>
        <Card className={classes.root}>
            <CardContent>
              <Typography className={classes.cardtitle} color="textSecondary" gutterBottom>
                Meditation
              </Typography>
              <Typography component="p">
                Meditation is the place to enter your meditation content & view it. Click the button below to go to Meditation dashboard.
              </Typography>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <NavLink to={`${this.props.match.url}/Meditation`} className={classes.navlink}>
                <Button className={classes.button}>Meditation Dashboard</Button>
              </NavLink>
            </CardActions>
          </Card>
        </GridItem>
        <GridItem md={4} lg={4} sm={12} xs={12} style={{paddingTop:"25px"}}>
        <Card className={classes.root}>
            <CardContent>
              <Typography className={classes.cardtitle} color="textSecondary" gutterBottom>
                Curriculum
              </Typography>
              <Typography component="p">
                Curriculum is the place to enter your curriculum content and view it. Click the button below to go to curriculum dashboard.
              </Typography>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <NavLink to={`${this.props.match.url}/Curriculum`} className={classes.navlink}>
                <Button className={classes.button}>Curriculum Dashboard</Button>
              </NavLink>
            </CardActions>
          </Card>
        </GridItem>

        <GridItem md={4} lg={4} sm={12} xs={12} style={{paddingTop:"25px"}}>
        <Card className={classes.root}>
            <CardContent>
              <Typography className={classes.cardtitle} color="textSecondary" gutterBottom>
                AFB 
              </Typography>
              <Typography component="p"style={{paddingLeft: "8px",paddingRight: "9px"}}>
                AFB is the place where you can enter your AFB content and view it. Click the button below to go to AFB dashboard.
              </Typography>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <NavLink to={`${this.props.match.url}/AFB`} className={classes.navlink}>
                <Button className={classes.button}>AFB Dashboard</Button>
              </NavLink>
            </CardActions>
          </Card>
        </GridItem>
      </GridContainer>
      <br/><br/><br/>
    </div>
  );
}
}
export default withStyles(styles, { withTheme: true })(AuthenticatedPage()(ArticleHomePage));